/**
 * The names on the box (docs/spec/README, "Decisions you may want to overrule" #1). Change them
 * here and nowhere else.
 */
export const GAME_NAME = 'STONEFALL';
export const HERO_NAME = 'DIGBY';
export const VERSION = '0.1.2';
export const TRIBUTE =
  'A tribute to Boulder Dash (1984) by Peter Liepa with Chris Gray, published by First Star Software. '
  + 'STONEFALL is not affiliated with or endorsed by the owners of Boulder Dash.';
